export function containsAllSearch (items: any[], terms?: string[], itemKey = 'text') {
  if (terms?.length) {
    return items.filter((item) => {
      const lower = item[itemKey].toLowerCase()
      return terms?.every(term => lower.includes(term.toLowerCase()) || '')
    })
  } else {
    return items
  }
}
